import { Box } from '@chakra-ui/react'
import { type ReactNode } from 'react'
import { classNames } from '~/utils/helpers'

export const containerMaxWidth = {
  base: '100%',
  sm: '29em',
  md: '45em',
  lg: '60em',
  xl: '71.5625em',
  '2xl': '90em',
}

export const containerGutter = '16px'

const containerMaxWidthFluid = '100%'

export default function Container(props: {
  children?: ReactNode
  fluid?: Boolean
  width?: string
  className?: string
}) {
  const { fluid, width, children, ...passThroughProps } = props

  return (
    <Box
      className={classNames(['container', props?.className])}
      marginLeft="auto"
      marginRight="auto"
      paddingLeft={containerGutter}
      paddingRight={containerGutter}
      maxWidth={fluid ? containerMaxWidthFluid : containerMaxWidth}
      {...passThroughProps}
      width={width ?? 'auto'}
    >
      {children}
    </Box>
  )
}
